export enum POD_PAYMENT_PAYER_TYPE {
  DIRECT_PAYMENT = 'DIRECT_PAYMENT',
  PARENT_PAYMENT = 'PARENT_PAYMENT',
}

export type PodPaymentPayerType = keyof typeof POD_PAYMENT_PAYER_TYPE

export enum PAYMENT_STATUS_TYPE {
  PAID = 'PAID',
  PENDING = 'PENDING',
}

export type PodPaymentStatusType = keyof typeof PAYMENT_STATUS_TYPE

export enum PAYMENT_STEP_TYPE {
  PAYMENT_FORM = 'PAYMENT_FORM',
  PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_NOT_AVAILABLE = 'PAYMENT_NOT_AVAILABLE',
  STALE_PAYMENT_INFO = 'STALE_PAYMENT_INFO',
}

export type PodPaymentStepType = keyof typeof PAYMENT_STEP_TYPE
